import Icon from '@/components/ui/AppIcon';

interface Benefit {
  id: number;
  icon: string;
  title: string;
  description: string;
}

const WhyChooseSection = () => {
  const benefits: Benefit[] = [
    {
      id: 1,
      icon: 'ShieldCheckIcon',
      title: 'Desert Climate Experts',
      description: 'Specialized knowledge of Phoenix weather challenges including monsoon stains, dust storms, and intense UV damage'
    },
    {
      id: 2,
      icon: 'SparklesIcon',
      title: 'Professional Equipment',
      description: 'Commercial-grade pressure washers and eco-friendly cleaning solutions designed for desert conditions'
    },
    {
      id: 3,
      icon: 'ClockIcon',
      title: 'Fast & Reliable',
      description: 'Quick response times, efficient service, and flexible scheduling to minimize disruption to your routine'
    },
    {
      id: 4,
      icon: 'CurrencyDollarIcon',
      title: 'Transparent Pricing',
      description: 'Upfront quotes with no hidden fees, competitive rates, and satisfaction guaranteed on every job'
    },
    {
      id: 5,
      icon: 'UserGroupIcon',
      title: 'Experienced Team',
      description: 'Trained professionals with years of experience serving Phoenix Metro homeowners and businesses'
    },
    {
      id: 6,
      icon: 'HeartIcon',
      title: 'Customer Focused',
      description: 'Dedicated to exceeding expectations with personalized service and attention to detail on every project'
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-background">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12 md:mb-16">
            <h2 className="font-headline font-bold text-3xl md:text-4xl lg:text-5xl text-foreground mb-4">
              Why Choose Phoenix Patio Pro
            </h2>
            <p className="font-body text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto">
              Trusted by Phoenix Metro homeowners for reliable, professional patio cleaning services
            </p>
          </div>

          {/* Benefits Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {benefits.map((benefit) => (
              <div
                key={benefit.id}
                className="flex flex-col items-center text-center p-6 rounded-lg hover:bg-card transition-brand"
              >
                <div className="w-16 h-16 bg-desert-gradient rounded-full flex items-center justify-center mb-4 shadow-brand">
                  <Icon name={benefit.icon as any} size={32} className="text-white" />
                </div>
                <h3 className="font-headline font-semibold text-xl text-foreground mb-3">
                  {benefit.title}
                </h3>
                <p className="font-body text-muted-foreground leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>

          {/* Stats Section */}
          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="font-headline font-bold text-4xl md:text-5xl text-primary mb-2">500+</div>
              <div className="font-body text-muted-foreground">Happy Customers</div>
            </div>
            <div className="text-center">
              <div className="font-headline font-bold text-4xl md:text-5xl text-primary mb-2">10+</div>
              <div className="font-body text-muted-foreground">Years Experience</div>
            </div>
            <div className="text-center">
              <div className="font-headline font-bold text-4xl md:text-5xl text-primary mb-2">20+</div>
              <div className="font-body text-muted-foreground">Cities Served</div>
            </div>
            <div className="text-center">
              <div className="font-headline font-bold text-4xl md:text-5xl text-primary mb-2">100%</div>
              <div className="font-body text-muted-foreground">Satisfaction Rate</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;